



































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin';
import FavouriteTab from '@/components/modules/App/Profile/FavouriteTab.vue';
import BookingTab from '@/components/modules/App/Profile/BookingTab.vue';
import { mapGetters } from 'vuex';
import { storeModuleName } from '@/views/App/Profile/store';
import { CatalogItem } from '@/requests/mainApi';
import MyFlatsVue from './MyFlats.vue';
import Notifications from './Notifications/Notifications.vue';
import { AmoNotification } from '@/requests/mainApi/models/AmoNotification';
import Services from './Services/Services.vue';
import MyDeals from './Deals/MyDeals.vue';
import Instructions from '@/components/modules/App/Profile/Instructions/Instructions.vue';

type tabValue = 'favourite' | 'booking' | 'documents' | 'instructions' | 'objects' | 'deals' | 'notifications' | 'services';

interface Data {
  selectOption: tabValue;
}

interface Methods {
  switchTab: (key: tabValue) => void;
}

interface Computed {
  myFlats: CatalogItem[];
  unreadNotifications: AmoNotification[];
}

interface Props {}

export default Vue.extend({
  name: 'FlatsList',
  components: {
    objects: MyFlatsVue,
    deals: MyDeals,
    favourite: FavouriteTab,
    booking: BookingTab,
    instructions: Instructions,
    notifications: Notifications,
    services: Services,
  },
  mixins: [iconsMixin],
  data() {
    return {
      selectOption: 'objects',
    };
  },
  computed: {
    ...mapGetters(['unreadNotifications']),
    ...mapGetters(storeModuleName, ['myFlats']),
  },
  methods: {
    switchTab(key: tabValue) {
      if (this.selectOption === key) return;

      if (key === 'objects') {
        this.$analytics.logEvent('switch_objects', {
          screen: 'main',
        });
      }

      if (key === 'documents') {
        this.$analytics.logEvent('switch_documents', {
          screen: 'main',
        });
      }

      if (key === 'instructions') {
        this.$analytics.logEvent('switch_instructions', {
          screen: 'main',
        });
      }

      if (key === 'favourite') {
        this.$analytics.logEvent('switch_favorites', {
          screen: 'main',
        });
      }

      if (key === 'booking') {
        this.$analytics.logEvent('switch_reservation', {
          screen: 'main',
        });
      }

      if (key === 'notifications') {
        this.$analytics.logEvent('switch_notifications', {
          screen: 'main',
        });
      }

      if (key === 'services') {
        this.$analytics.logEvent('switch_services', {
          screen: 'main',
        });
      }

      this.selectOption = key;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
